import { computed } from "vue";
import { useRoute } from "vue-router";
import { useTitle } from "@vueuse/core";
import { projectPageStore } from "@/store/project-page";
import { clientPageStore } from "@/store/client-page";
import { generalStore } from "@/store/general";
import { resolvePageTitle } from "@/utils/pageTitle";

function queryValue(value: unknown): string {
    if (Array.isArray(value)) {
        return String(value[0] ?? "");
    }
    if (value === undefined || value === null) {
        return "";
    }
    return String(value);
}

/**
 * Определение заголовка вкладки.
 */
export function useDocumentTitle() {
    const route = useRoute();
    const projectStore = projectPageStore();
    const clientStore = clientPageStore();
    const general = generalStore();

    const projectName = computed(() => {
        const project = projectStore.openedProject;
        if (!project) {
            return "";
        }
        if (project.NameAccess === 0) {
            return "";
        }
        const routeId = queryValue(route.query.id);
        if (routeId && String(project.Id) !== routeId) {
            return "";
        }
        return project.Name || "";
    });

    const clientName = computed(() => {
        const client = clientStore.openedClient;
        if (!client) {
            return "";
        }
        if (client.NameAccess === 0) {
            return "";
        }
        const routeId = queryValue(route.query.id);
        if (routeId && String(client.Id) !== routeId) {
            return "";
        }
        return client.Name || "";
    });

    const analyticsName = computed(() => {
        const item = general.selectedItem;
        return item?.CombinedName || item?.Name || "";
    });

    const title = computed(() => {
        const mainPage = queryValue(route.query.page);
        let entityName = "";
        if (mainPage === "project") {
            entityName = projectName.value;
        }
        if (mainPage === "client") {
            entityName = clientName.value;
        }
        return resolvePageTitle({
            path: route.path,
            mainPage,
            entityName,
            analyticsName: analyticsName.value,
        });
    });

    useTitle(title, { restoreOnUnmount: false });

    return { title };
}
